import { gql } from '@apollo/client';

export const deleteAccountVehicle = gql`
  mutation deleteAccountVehicle($input: DeleteAccountVehicleInput!) {
    deleteAccountVehicle(input: $input) {
      success
    }
  }
`;
